import React, { useState } from "react";
import "./Register.css";
//FORMIK
import * as Yup from "yup";
import { useFormik } from "formik";
//PRIMEREACT
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { classNames } from "primereact/utils";
import { InputMask } from "primereact/inputmask";
import { Calendar } from "primereact/calendar";
//COMPONENTES
import Messages from "../Others/Messages";
import Header from "../Header";
import Footer from "../Footer";
import Information from "./Information";
//SERVICES
import regex from "../../services/regex";
import { toast } from "react-toastify";
// import authentication from "../../services/authentication";
import registers from "../../services/registers";
// import fglobales from "../../services/fglobales";
//MEDIA
import Data from "../../assets/pdf/data.pdf";

function Register({ configurations, theme }) {
  const [submitted, setSubmitted] = useState(false);
  const [registrer, setRegistrer] = useState(false);
  //CONTROL DE MENSAJES -->
  const [showMessage, setShowMessage] = useState(false);
  const [colorIcon, setColorIcon] = useState("");
  const [icon, setIcon] = useState("");
  const [headerMessage, setHeaderMessage] = useState("");
  const [message, setMessage] = useState("");
  //CONTROL DE MENSAJES <--

  const formik = useFormik({
    initialValues: {
      name: "",
      surname: "",
      cc: "",
      dateBirth: "",
      mobilePhone: "",
      address: "",
      city: "",
      emailFrom: "",
      dateFinanciacion: "",
      code: "",
      store: "",
      ppd: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("El nombre es obligatorio"),
      surname: Yup.string().required("El apellido es obligatorio"),
      cc: Yup.string().required("El documento de identidad es obligatorio"),
      dateBirth: Yup.date().required("La fecha de nacimiento es obligatoria"),
      mobilePhone: Yup.string()
        .matches(regex.mobilePhone, "El campo debe tener 10 dígitos")
        .required("Este campo es requerido"),
      address: Yup.string().required("La dirección es obligatoria"),
      city: Yup.string().required("La ciudad es obligatoria"),
      emailFrom: Yup.string()
        .email("El correo electronico es invalido")
        .required("El correo electrónico es obligatorio"),
      dateFinanciacion: Yup.date().required("Requiere fecha de financiación"),
      code: Yup.string().required("El documento de identidad es obligatorio"),
      store: Yup.string().required("El Almacén es obligatorio"),
      ppd: Yup.boolean()
        .required(
          "El tratamiento de datos, los términos y condiciones deben ser aceptados."
        )
        .oneOf(
          [true],
          "El tratamiento de datos, los términos y condiciones deben ser aceptados."
        ),
    }),
    onSubmit: async (formData) => {
      try {
        setSubmitted(true);

        const newUser = formData;
        newUser.cc = `${newUser.cc}`;
        newUser.cc = newUser.cc.trim();
        newUser.emailFrom = newUser.emailFrom.trim();
        newUser.email = `${newUser.cc}999@mamabrilla.com`;
        newUser.password = `${newUser.cc}999`;
        newUser.mobilePhone = newUser.mobilePhone.replace(regex.phone, "$1");
        newUser.mobilePhone = newUser.mobilePhone.replace(regex.space, "");
        newUser.mobilePhone = newUser.mobilePhone.replace("-", "");

        if (configurations.number < configurations.maxUser) {
          registers
            .registerOrLoginWithDNI(formData)
            .then((result) => {
              setSubmitted(false);
              toast.success(result);
            })
            .catch((error) => {
              setSubmitted(false);
              toast.error(error);
              console.log(error);
            });
        } else {
          toast.error(`Lo sentimos nuestros cupos estan completos`);
        }
      } catch (error) {
        toast.error(error);
        console.log(error);
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const actionHiddenMessage = () => {
    setShowMessage(false);
    hideDialog();
  };

  const hideDialog = () => {
    setShowMessage(false);
    setSubmitted(false);
  };

  const openTermin = () => {
    setIcon("pi-file-word");
    setColorIcon("secondary-color");
    setHeaderMessage(
      "Términos y condiciones y consentimiento informado de tratamiendo de datos y uso de imagen."
    );
    setMessage(
      <>
        <a href={Data} target="_blank" rel="noopener noreferrer">
          Tratamiento de datos
        </a>
      </>
    );
    setShowMessage(true);
  };

  return (
    <>
      <Header theme={theme} />

      {registrer ? (
        <>
          <div className="grid">
            <div className="col-10 col-offset-1 md:col-4">
              <div className="titleConten">
                <h2>Diligencia tus datos personales</h2>
              </div>
            </div>
          </div>
          <div className="grid-nogutter">
            <div className="col-10 col-offset-1">
              <div className="grid">
                <div className="col-12 md:col-7 p-0">
                  <div className="grid-nogutter contentLogin">
                    <div className="col-12">
                      {configurations.number + 1 <= configurations.maxUser ? (
                        <>
                          <form
                            onSubmit={formik.handleSubmit}
                            className="p-fluid pt-4"
                          >
                            <div className="grid">
                              <div className="col-12">
                                <InputText
                                  placeholder="Nombres: *"
                                  id="name"
                                  name="name"
                                  value={formik.values.name}
                                  onChange={formik.handleChange}
                                  disabled={submitted}
                                  className={classNames(
                                    {
                                      "p-invalid": isFormFieldValid("name"),
                                    },
                                    "textForm"
                                  )}
                                />
                                {getFormErrorMessage("name")}
                              </div>

                              <div className="col-12">
                                <InputText
                                  placeholder="Apellidos: *"
                                  id="surname"
                                  name="surname"
                                  value={formik.values.surname}
                                  onChange={formik.handleChange}
                                  disabled={submitted}
                                  className={classNames(
                                    {
                                      "p-invalid": isFormFieldValid("surname"),
                                    },
                                    "textForm"
                                  )}
                                />
                                {getFormErrorMessage("surname")}
                              </div>

                              <div className="col-12">
                                <InputText
                                  placeholder="N° Cédula: *"
                                  type="tel"
                                  id="cc"
                                  name="cc"
                                  value={formik.values.cc}
                                  onChange={formik.handleChange}
                                  disabled={submitted}
                                  className={classNames(
                                    {
                                      "p-invalid": isFormFieldValid("cc"),
                                    },
                                    "textForm"
                                  )}
                                />
                                {getFormErrorMessage("cc")}
                              </div>

                              <div className="col-12 md:col-6">
                                <span className="p-float-label">
                                  <Calendar
                                    id="dateBirth"
                                    name="dateBirth"
                                    value={formik.values.dateBirth}
                                    onChange={formik.handleChange}
                                    disabled={submitted}
                                    dateFormat="dd/mm/yy"
                                    placeholder="Fecha de nacimiento: *"
                                    className={classNames(
                                      {
                                        "p-invalid":
                                          isFormFieldValid("dateBirth"),
                                      },
                                      "dateBorder"
                                    )}
                                  />
                                  <label htmlFor="birth_date">
                                    Fecha de nacimiento: *
                                  </label>
                                </span>
                                {getFormErrorMessage("dateBirth")}
                              </div>

                              <div className="col-12 md:col-6">
                                <span className="p-float-label">
                                  <InputMask
                                    id="mobilePhone"
                                    name="mobilePhone"
                                    mask="(999) 999-9999"
                                    value={formik.values.mobilePhone}
                                    onChange={(e) =>
                                      formik.setFieldValue(
                                        "mobilePhone",
                                        e.value
                                      )
                                    }
                                    disabled={submitted}
                                    className={classNames(
                                      {
                                        "p-invalid":
                                          isFormFieldValid("mobilePhone"),
                                      },
                                      "textForm"
                                    )}
                                    type="tel"
                                  ></InputMask>
                                  <label htmlFor="ssn_input">Celular: *</label>
                                </span>
                              </div>

                              <div className="col-12 md:col-6">
                                <InputText
                                  placeholder="Dirección: *"
                                  id="address"
                                  name="address"
                                  value={formik.values.address}
                                  onChange={formik.handleChange}
                                  disabled={submitted}
                                  className={classNames(
                                    {
                                      "p-invalid": isFormFieldValid("address"),
                                    },
                                    "textForm"
                                  )}
                                />
                                {getFormErrorMessage("address")}
                              </div>

                              <div className="col-12 md:col-6">
                                <InputText
                                  placeholder="Ciudad/Municipio: *"
                                  id="city"
                                  name="city"
                                  value={formik.values.city}
                                  onChange={formik.handleChange}
                                  disabled={submitted}
                                  className={classNames(
                                    {
                                      "p-invalid": isFormFieldValid("city"),
                                    },
                                    "textForm"
                                  )}
                                />
                                {getFormErrorMessage("city")}
                              </div>

                              <div className="col-12">
                                <InputText
                                  placeholder="Correo electrónico: *"
                                  id="emailFrom"
                                  name="emailFrom"
                                  value={formik.values.emailFrom}
                                  onChange={formik.handleChange}
                                  disabled={submitted}
                                  className={classNames(
                                    {
                                      "p-invalid":
                                        isFormFieldValid("emailFrom"),
                                    },
                                    "textForm"
                                  )}
                                />

                                {getFormErrorMessage("emailFrom")}
                              </div>

                              <div className="col-12">
                                <span className="p-float-label">
                                  <Calendar
                                    id="dateFinanciacion"
                                    name="dateFinanciacion"
                                    value={formik.values.dateFinanciacion}
                                    onChange={formik.handleChange}
                                    disabled={submitted}
                                    dateFormat="dd/mm/yy"
                                    placeholder="Fecha de financiación: *"
                                    className={classNames(
                                      {
                                        "p-invalid":
                                          isFormFieldValid("dateFinanciacion"),
                                      },
                                      "dateBorder"
                                    )}
                                  />
                                  <label htmlFor="birth_date">
                                    Fecha de financiación: *
                                  </label>
                                </span>
                                {getFormErrorMessage("dateFinanciacion")}
                              </div>

                              <div className="col-12">
                                <InputText
                                  placeholder="N° de Contrato: *"
                                  id="code"
                                  name="code"
                                  value={formik.values.code}
                                  onChange={formik.handleChange}
                                  disabled={submitted}
                                  className={classNames(
                                    {
                                      "p-invalid": isFormFieldValid("code"),
                                    },
                                    "textForm"
                                  )}
                                />
                                {getFormErrorMessage("code")}
                              </div>

                              <div className="col-12">
                                <InputText
                                  placeholder="Almacén en el que financió: *"
                                  id="store"
                                  name="store"
                                  value={formik.values.store}
                                  onChange={formik.handleChange}
                                  disabled={submitted}
                                  className={classNames(
                                    {
                                      "p-invalid": isFormFieldValid("store"),
                                    },
                                    "textForm"
                                  )}
                                />
                                {getFormErrorMessage("store")}
                              </div>

                              <div className="col-12">
                                <div className="field-checkbox">
                                  <Checkbox
                                    onChange={(e) =>
                                      formik.setFieldValue("ppd", e.checked)
                                    }
                                    disabled={submitted}
                                    checked={formik.values.ppd}
                                    inputId="ppd"
                                  />
                                  <label
                                    htmlFor="binary"
                                    className={classNames(
                                      {
                                        "p-error": isFormFieldValid("ppd"),
                                      },
                                      "checked"
                                    )}
                                    onClick={() => {
                                      openTermin();
                                    }}
                                  >
                                    Confirmo lectura de términos y condiciones y
                                    consentimiento informado de tratamiendo de
                                    datos y uso de imagen.
                                  </label>
                                </div>
                                {getFormErrorMessage("ppd")}
                              </div>

                              <div className="col-12 md:col-4 md:col-offset-4">
                                <button
                                  className="hvr-icon-spin btn-game"
                                  disabled={submitted}
                                  type="submit"
                                >
                                  Siguiente{" "}
                                  <i className="pi pi-heart-fill hvr-icon"></i>
                                </button>
                              </div>
                            </div>
                          </form>
                        </>
                      ) : (
                        <>
                          <p className="noDisponible">
                            En este momento no hay cupos disponibles para la
                            actividad
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-0 md:col-5"></div>
              </div>
            </div>
            <br />
            <br />
          </div>
        </>
      ) : (
        <Information setRegistrer={setRegistrer} />
      )}

      <Footer />

      <Messages
        showMessage={showMessage}
        actionHidden={actionHiddenMessage}
        headerMessage={headerMessage}
        message={message}
        icon={icon}
        color={colorIcon}
      />
    </>
  );
}

export default Register;
